import { useEffect, useState, useRef } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslation } from "react-i18next";
import { adminRequester, requester } from "App";
import InputText from "components/inputs/InputText";
import Select from "react-select";
import CheckCircle from "components/inputs/checkBox/CheckCircle";
import ButtonEclipse from "components/buttons/ButtonEclipse";
import ModalBase from "modals/base/ModalBase";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import { style } from "components/buttons/AdminCustomButton";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import P from "components/P";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import { modalClasses } from "@mui/material";
import InputPassword from "components/inputs/InputPassword";

const passwordChangeModal = NiceModal.create((props) => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [false, false];
  const [width, height] = ["min(80%, 400px)", "160px"];
  const withCloseButton = false;
  const clickOutsideToClose = true;
  const title = "";
  const buttonText = t("close");
  const modal = useRef();
  // const inputs = useRef([]);
  const input = useRef();
  const [valid, setValid] = useState(false);
  /*
    props format
    {
        buttons : object / for make buttons
        mesage: string / text for showing this modal's description
        data: any / transfer data to Click, if u want more data, Do update data
    }
    //
    buttons format
    {
        text : string / button's name
        style : object / button's style
        onClick: function / button action, whethere async or not
        close: boolean / if true , press with close modal, default : true
    }
 */
  const onSaveClick = () => {
    adminRequester.updateCustomer(props.id, {
      password: input.current.getValue(),
    });
    modal.current.close();
  };
  const onCancelClick = () => {
    modal.current.close();
  };
  return (
    <ModalBase
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
    >
      <PaddingWrapper padding={"10px 20px"}>
        <VerticalFlex gap={10} height={"100%"}>
          {/* <FlexChild>
            <InputText
              placeHolder="새 비밀번호"
              ref={(el) => (inputs.current[0] = el)}
              type="password"
            />
          </FlexChild>
          <FlexChild>
            <InputText
              placeHolder="비밀번호 확인"
              ref={(el) => (inputs.current[1] = el)}
              type="password"
              manualValid
              onChange={(value) =>
                setValid(value ? value === inputs.current[0].getValue() : null)
              }
              feedback="비밀번호가 일치하지 않습니다."
            />
          </FlexChild> */}
          <FlexChild>
            <InputPassword
              signUp
              confirmVisible
              placeHolder="새비밀번호"
              placeHolderComfirm="비밀번호 확인"
              onMatch={(value) => setValid(value)}
              ref={input}
            />
          </FlexChild>
          <FlexChild>
            <HorizontalFlex justifyContent="flex-end" gap={10}>
              <AdminCustomButton
                style={style.white_border}
                text="취소"
                onClick={onCancelClick}
              />
              <AdminCustomButton
                style={style.white_border}
                text="변경"
                onClick={onSaveClick}
                disabled={!valid}
              />
            </HorizontalFlex>
          </FlexChild>
        </VerticalFlex>
      </PaddingWrapper>
    </ModalBase>
  );
});

export default passwordChangeModal;
